export default __webpack_public_path__ + "static/media/likiee-logo.72e86fb5.png";